import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'element-ui/lib/theme-chalk/index.css'
import './config/element/index'
import moment from 'moment'
import Bus from '@/utils/bus.js'
import './utils/directive'
import './utils/drag'
import { VueJsonp } from 'vue-jsonp'

Vue.config.productionTip = false
Vue.prototype.$moment = moment
Vue.prototype.$bus = Bus
Vue.use(VueJsonp)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
